export default "__VITE_ASSET__81d13266__"